import type { PetitionDetailsDataQuery } from './api.graphql';

type Petition = NonNullable<PetitionDetailsDataQuery['petition']>;

export function anonymizeForBots(petition: Petition): Petition {
	return {
		...petition,
		commentsConnection: {
			...petition.commentsConnection,
			nodes: petition.commentsConnection.nodes.map((node) => ({
				...node,
				user: {
					...node.user,
					displayName: node.user.firstName,
					shortDisplayName: node.user.firstName,
					city: null,
					photo: null,
				},
			})),
		},
		recentPublicSignersConnectionV2: {
			...petition.recentPublicSignersConnectionV2,
			edges: petition.recentPublicSignersConnectionV2.edges.map((edge) => ({
				...edge,
				user: {
					...edge.user,
					displayName: edge.user.firstName,
					firstName: edge.user.firstName,
					lastName: '',
					photo: null,
				},
			})),
		},
	};
}
